import { useEffect } from "react"
import { tableStore } from "@/routes/org/_components/table/table-store"
import useIsMobile from "../../../../hooks/use-is-mobile"

const useResponsiveRowsPerPage = () => {
  const isMobile = useIsMobile()

  useEffect(() => {
    tableStore.getState().setPageMeta({ size: isMobile ? 10 : 20 })
  }, [isMobile])
}

export default useResponsiveRowsPerPage
